"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var action_dto_1 = require("../model/action.dto");
var actiondetail_dto_1 = require("../model/actiondetail.dto");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var action_wth_expression_dto_1 = require("../model/action-wth-expression.dto");
/**
 * Dummy implementation of ActionService
 */
var DummyActionService = /** @class */ (function () {
    function DummyActionService(http, applicationPropertiesService) {
        var _this = this;
        this.http = http;
        /**
         * Key for getting actions' json file
         * @type {string}
         */
        this.actionApiUrlKey = 'workflow-actions-service-url';
        this.actionRoleMap = new Map();
        this.actionMap = new Map();
        this.actionProjectMap = new Map();
        this.actions = [];
        this.dataLoaded = new Promise(function (resolve) {
            applicationPropertiesService
                .getProperty(_this.actionApiUrlKey)
                .then(function (url) {
                http.get(url).toPromise().then(function (response) {
                    _this.actionRoleMap = _this.extractActions(response);
                    Array.from(_this.actionRoleMap).forEach(function (element) {
                        // element[1] is map's value
                        element[1].forEach(function (action) {
                            _this.actionMap.set(action.getId(), action);
                        });
                    });
                    resolve(true);
                });
            })
                .catch(DummyActionService_1.handleError);
        });
    }
    DummyActionService_1 = DummyActionService;
    /**
     * Get actions by initial state id
     * @param stateId
     * @returns {Promise<Array<ActionDto>>}
     */
    DummyActionService.prototype.getActionsByStateId = function (stateId) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                resolve(_this.actions
                    .filter(function (actionDetail) { return actionDetail.getInitialStateId() === stateId; })
                    .map(DummyActionService_1.getActionDtoFromDetail));
            });
        });
    };
    /**
     * Get actions with expressions by initial state id
     * @param stateId
     * @returns {Promise<Array<ActionWithExpressionDto>>}
     */
    DummyActionService.prototype.getActionsWithExpressionByStateId = function (stateId) {
        return this.getActionsByStateId(stateId).then(function (value) { return value.map(function (action) { return new action_wth_expression_dto_1.ActionWithExpressionDto(action, 'expr', ['ruleExpr']); }); });
    };
    /**
     * Get all actions
     * @returns {Promise<Array<ActionDto>>}
     */
    DummyActionService.prototype.getActions = function () {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                resolve(Array.from(_this.actionMap.values())
                    .map(DummyActionService_1.getActionDtoFromDetail));
            });
        });
    };
    /**
     * Get actions by process id
     * @param processId
     * @returns {Promise<Array<ActionDto>>}
     */
    DummyActionService.prototype.getActionsByProcessId = function (processId) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                resolve(_this.actionProjectMap
                    .get(processId)
                    .map(DummyActionService_1.getActionDtoFromDetail));
            });
        });
    };
    /**
     * Get actions by initial state id and roles
     * @param stateId
     * @param roles
     * @returns {Promise<Array<ActionDto>>}
     */
    DummyActionService.prototype.getActionsByRoles = function (stateId, roles) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var actions = [];
                roles.forEach(function (element) { return actions = actions.concat(_this.actionRoleMap
                    .get(element)
                    .filter(function (action) { return action.getInitialStateId() === stateId; })).map(DummyActionService_1.getActionDtoFromDetail); });
                resolve(actions);
            });
        });
    };
    /**
     * Get action by action id
     * @param actionId
     * @returns {Promise<ActionDto>}
     */
    DummyActionService.prototype.getAction = function (actionId) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                resolve(_this.actionMap.get(actionId));
            });
        });
    };
    /**
     * Save the given action
     * @param actionDetailDto detailed object of action
     * @returns {Promise<number>} added action's id
     */
    DummyActionService.prototype.save = function (actionDetailDto) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var size = _this.actionMap.size;
                _this.actionMap.set(size + 1, actionDetailDto);
                resolve(size + 1);
            });
        });
    };
    /**
     * Update the given action
     * @param id action's id to be updated
     * @param actionDetailDto
     * @returns {Promise<number>} updated action's id
     */
    DummyActionService.prototype.update = function (id, actionDetailDto) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                _this.actionMap.set(id, actionDetailDto);
                resolve(id);
            });
        });
    };
    /**
     * Creates Action objects from json. Also creates actionProjectMap map and actions array
     * @param data
     * @returns {Map<number, Array<ActionDetailDto>>} map where the key is role id,the value is actions' array
     */
    DummyActionService.prototype.extractActions = function (data) {
        var _this = this;
        var actionsRoleMap = new Map();
        data.forEach(function (element) {
            element.roleIds.forEach(function (roleId) {
                if (actionsRoleMap.has(roleId)) {
                    actionsRoleMap.get(roleId).push(DummyActionService_1.createActionDetailDto(element.action));
                }
                else {
                    actionsRoleMap.set(roleId, [DummyActionService_1.createActionDetailDto(element.action)]);
                }
            });
            element.processIds.forEach(function (processId) {
                if (_this.actionProjectMap.has(processId)) {
                    _this.actionProjectMap.get(processId).push(DummyActionService_1.createActionDetailDto(element.action));
                }
                else {
                    _this.actionProjectMap.set(processId, [DummyActionService_1.createActionDetailDto(element.action)]);
                }
            });
            _this.actions.push(DummyActionService_1.createActionDetailDto(element.action));
        });
        return actionsRoleMap;
    };
    DummyActionService.createActionDetailDto = function (item) {
        var id = Number(item.id);
        var name = DummyActionService_1.convertObjectToMap(item.name);
        var description = DummyActionService_1.convertObjectToMap(item.description || {});
        var nextStateId = Number(item.nextStateId);
        var initialStateId = Number(item.initialStateId);
        var templateId = Number(item.templateId);
        var formId = item.formId && Number(item.formId);
        return new actiondetail_dto_1.ActionDetailDto(id, name, description, nextStateId, initialStateId, templateId, formId);
    };
    DummyActionService.getActionDtoFromDetail = function (actionDetailDto) {
        return new action_dto_1.ActionDto(actionDetailDto.getId(), actionDetailDto.getNameMap(), actionDetailDto.getDescriptionMap(), actionDetailDto.getInitialStateId(), actionDetailDto.getTargetStateId(), actionDetailDto.getFormId());
    };
    DummyActionService.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var prop = _a[_i];
            strMap.set(Number(prop), obj[prop]);
        }
        return strMap;
    };
    /**
     * Handle errors
     */
    DummyActionService.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    DummyActionService = DummyActionService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], DummyActionService);
    return DummyActionService;
    var DummyActionService_1;
}());
exports.DummyActionService = DummyActionService;
//# sourceMappingURL=dummy-action.service.js.map